module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/AU-47186b137532bd653bd97f753d29c6a1.png";